
enum BusyLevel {
  NoTime = 'NoTime',
  FairlyBusy = 'FairlyBusy',
  NotBudy = 'NotBusy',
  Flexible = 'Flexible',
}

const busyLevelQuestion = {
  name: 'busyLevel',
  title: 'How busy are you typically?',
  description: 'This won’t affect your plan, it just helps us understand how much time you have to work with.',
  type: 'radiogroup',
  choices: [
    {
      value: BusyLevel.NoTime,
      text: `My days are packed`,
    },
    {
      value: BusyLevel.FairlyBusy,
      text: `I make time to relax when I can`,
    },
    {
      value: BusyLevel.NotBudy,
      text: `I keep space open for priorities`,
    },
    {
      value: BusyLevel.Flexible,
      text: `I have lots of control over my day`,
    },
  ],
  isRequired: true,
}

export {
  BusyLevel,
  busyLevelQuestion,
}